import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Shield, Globe, Headphones, FileCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { SchedulingForm } from "@/components/SchedulingForm";

export const HomeCTA = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-primary to-primary/80 text-white relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 bg-white/20 rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -40, 0],
              opacity: [0.2, 0.5, 0.2],
              scale: [1, 1.5, 1],
            }}
            transition={{
              duration: 4 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Ready to Deploy Enterprise Connectivity?
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-12">
            Our connectivity specialists design solutions matching your technical requirements, coverage needs, and budget—from initial consultation through 24/7 ongoing support.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button 
                size="lg"
                onClick={() => setIsFormOpen(true)}
                className="text-lg px-10 py-6 h-auto bg-background hover:bg-background-secondary text-foreground"
              >
                Schedule Consultation
              </Button>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button 
                size="lg"
                onClick={() => setIsFormOpen(true)}
                className="text-lg px-10 py-6 h-auto bg-background/90 hover:bg-background border border-foreground/20 text-foreground"
              >
                Get Quote
              </Button>
            </motion.div>
          </div>

          {/* Bottom Features */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="flex flex-wrap justify-center gap-6 md:gap-8 text-white/90"
          >
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5" />
              <span className="font-semibold">99.9% uptime SLA</span>
            </div>
            <div className="flex items-center gap-2">
              <Globe className="w-5 h-5" />
              <span className="font-semibold">Global deployment</span>
            </div>
            <div className="flex items-center gap-2">
              <Headphones className="w-5 h-5" />
              <span className="font-semibold">US-based support</span>
            </div>
            <div className="flex items-center gap-2">
              <FileCheck className="w-5 h-5" />
              <span className="font-semibold">No long-term contracts</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
      
      <SchedulingForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </section>
  );
};
